
import { defineComponent, reactive } from 'vue'
export default defineComponent({
  setup() {
    const state = reactive({
      imgs: {
        Github: require('@/assets/img/github.svg'),
        StandardJS: require('@/assets/img/StandardJS.svg'),
        TS: require('@/assets/img/TS.png'),
        Vue: require('@/assets/img/vue.png'),
        Me: require('@/assets/img/me.svg'),
      },
    })
    return { state }
  },
})
